import { colorOpacity, customTheme } from 'theme';

import { defaultSelectStyles } from 'components/DataEntry';

// The look of the entity dropdown and the account picker above it.
export const sourceEntitySelectStyles = {
  ...defaultSelectStyles(),
  menu: provided => ({
    ...provided,
    width: 'max-content',
    minWidth: '100%',
  }),
  control: (styles, props) => ({
    ...defaultSelectStyles().control(styles, props),
    backgroundColor: '#fff',
    overflow: 'hidden',
  }),
  container: (styles, props) => ({
    ...defaultSelectStyles().container(styles, props),
    backgroundColor: '#fff',
    borderRadius: customTheme.radii.fieldBorderRadius,
    overflow: 'hidden',
  }),
  option: (provided, props) => {
    const defaultStyles = defaultSelectStyles().option(provided, props);

    return {
      ...defaultStyles,
      backgroundColor: props.isSelected
        ? colorOpacity(customTheme.colors.primary, 0.12)
        : '#fff',
      color: props.isSelected ? customTheme.colors.primary : '#000',
      fontWeight: props.isSelected ? 600 : 400,
      boxShadow: props.isSelected
        ? `inset 3px 0 0 ${customTheme.colors.primary}`
        : 'none',
      '&:hover': {
        ...defaultStyles['&:hover'],
        backgroundColor: props.isSelected
          ? colorOpacity(customTheme.colors.primary, 0.12)
          : 'hover',
      },
    };
  },
};
